"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _react = require("react");

var _reactFeather = require("react-feather");

var _react2 = require("@emotion/react");

var _theme = _interopRequireDefault(require("../../theme/theme"));

var _ = require("..");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var modalRoot = document.getElementById("choom-modal");

var Modal = function Modal(_ref) {
  var className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;

  var _useState = (0, _react.useState)(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClose = function handleClose() {
    onClose();
    setOpen(false);
  };

  var elRef = (0, _react.useRef)(null);

  if (!elRef.current) {
    elRef.current = document.createElement("div");
  }

  (0, _react.useEffect)(function () {
    modalRoot.appendChild(elRef.current);
    return function () {
      modalRoot.removeChild(elRef.current);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setOpen(isOpen);
    return function () {
      setOpen(false);
    };
  }, [isOpen]);
  var content = open ? (0, _react2.jsx)("section", {
    className: className,
    css: (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        position: fixed;\n        z-index: 3000;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n\n        padding: ", ";\n\n        background: ", ";\n        color: ", ";\n\n        font-family: ", ";\n      "])), _theme["default"].spaceOneAndHalf, _theme["default"].colorLightTemp, _theme["default"].colorDarkTemp, _theme["default"].fontFamily)
  }, (0, _react2.jsx)("div", {
    css: (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          position: absolute;\n          top: ", ";\n          right: ", ";\n          z-index: 1000;\n        "])), _theme["default"].spaceOneAndHalf, _theme["default"].spaceOne)
  }, (0, _react2.jsx)(_.Button, {
    size: "small",
    isIcon: true,
    onClick: handleClose
  }, (0, _react2.jsx)(_reactFeather.X, null))), title && (0, _react2.jsx)(_.Heading, {
    level: "3",
    colorInherit: true,
    mb: "2"
  }, title), (0, _react2.jsx)("div", {
    css: (0, _react2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          position: relative;\n          z-index: 0;\n        "])))
  }, children)) : null;
  return /*#__PURE__*/(0, _reactDom.createPortal)(content, elRef.current);
};

Modal.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  onClose: _propTypes["default"].func
};
var _default = Modal;
exports["default"] = _default;